import { render, staticRenderFns } from "./Altas.vue?vue&type=template&id=a32c21c8&"
import script from "./Altas.vue?vue&type=script&lang=js&"
export * from "./Altas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports